module.exports = __webpack_public_path__ + "img/__icon_LAWETA.4fb4f56e.svg";